import { memo } from "react";
import Image from "next/image";

import sweatIconRound from "@public/sweat_icon_round.png";
import sweatIconSquare from "@public/sweat_icon_square.png";

type Props = {
  className?: string;
  type: "round" | "square";
};

function Logo({ className, type }: Props) {
  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
      }}
      className={className}
    >
      {type === "square" && (
        <Image
          src={sweatIconSquare}
          alt="Sweat logo with squared background"
          style={{ objectFit: "contain" }}
          quality={100}
          fill
        />
      )}

      {type === "round" && (
        <Image
          src={sweatIconRound}
          alt="Sweat logo with rounded background"
          style={{ objectFit: "contain" }}
          quality={100}
          fill
        />
      )}
    </div>
  );
}

export default memo(Logo);
